/**
 * Copyright (c) 2018
 * @summary TextArea Template
 * @author Mangesh Pimprikar,Ankur Vishwakarma,Poonam Banode,Irfan Bagwan
 *
 */
import React from 'react';
import { isFunction } from 'lodash/lang';

import TextLengthCounter from './TextLengthCounter';

class TextAreaTemplate extends React.Component {
  onChangeHandler = event => {
    this.props.onChangeTextHandler &&
      this.props.onChangeTextHandler(event, this.props.formId, this.props.formLabelId, this.props.templateData);
  };

  render({ props } = this) {
    const disabled = isFunction(props.isAbleToEdit) && !props.isAbleToEdit();
    return (
      <div
        className={
          props.customClassObject && props.customClassObject.containerClass
            ? props.customClassObject.containerClass
            : ''
        }
      >
        <textarea
          className={
            props.customClassObject && props.customClassObject.elementClass ? props.customClassObject.elementClass : ''
          }
          onChange={event => this.onChangeHandler(event)}
          value={props.templateData.inputValue || ''}
          maxLength="3000"
          disabled={disabled}
        />
        {props.isItemGroup && <TextLengthCounter characters={props.templateData.inputValue || ''} />}
      </div>
    );
  }
}
export default TextAreaTemplate;
